import { SVGProps } from "react";

const ShieldIcon = ({
  color,
  height,
  width,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 9.00802C2.5 6.34337 2.5 5.01104 2.8146 4.56281C3.12919 4.11459 4.38194 3.68577 6.88743 2.82813L7.36477 2.66474C8.67082 2.21767 9.32384 1.99414 10 1.99414C10.6762 1.99414 11.3292 2.21767 12.6352 2.66474L13.1126 2.82813C15.6181 3.68577 16.8708 4.11459 17.1854 4.56281C17.5 5.01104 17.5 6.34337 17.5 9.00802C17.5 9.41051 17.5 9.84699 17.5 10.3203C17.5 15.0187 13.9675 17.2987 11.7512 18.2669C11.15 18.5295 10.8494 18.6608 10 18.6608C9.15062 18.6608 8.85001 18.5295 8.2488 18.2669C6.03247 17.2987 2.5 15.0187 2.5 10.3203C2.5 9.84699 2.5 9.41051 2.5 9.00802Z"
        stroke={color ?? "#6F7794"}
        strokeWidth="1.5"
      />
      <path
        opacity="0.5"
        d="M10 6.99414V10.3275"
        stroke={color ?? "#6F7794"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        opacity="0.5"
        cx="10.0001"
        cy="12.8275"
        r="0.833333"
        fill="#6F7794"
      />
    </svg>
  );
};

export default ShieldIcon;
